import { FC /*, useState*/ } from 'react';
import { useHistory } from 'react-router-dom';
import { useStyles } from './styles';
import { Button, Grid, Paper /*, Modal*/ } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { handleCompanyUrl } from 'utils/organizationUtils';

export const InvoiceSentDialog: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const {
    upgradeLicenseStore: { setStep },
  } = useStore();

  // const [open, setOpen] = useState<boolean>(true);

  const handleGoToDasboard = (): void => {
    // setOpen(false);
    setStep('upgrade-form');
    history.push(handleCompanyUrl('/dashboard'));
  };

  return (
    <main className={classes.main}>
      <Paper className={classes.paper} elevation={3}>
        <p className={classes.title}>Invoice Sent</p>
        <p className={classes.text}>
          The email with the payment link was sent to your email. Please check it to complete the payment.
        </p>
        <Grid className={classes.buttonBox} container justify='space-between'>
          <Button className={classes.actionBtn} onClick={() => setStep('upgrade-form')}>
            Back
          </Button>
          <Button
            className={classes.actionBtn}
            startIcon={<DashboardIcon />}
            variant='contained'
            color='primary'
            onClick={handleGoToDasboard}
          >
            Go to Dashboard
          </Button>
        </Grid>
      </Paper>
    </main>
  );
});
